module.exports = __webpack_public_path__ + "img/iglushad.71a1a6dc.jpg";